import { Component } from '@angular/core';
import { ModalComponent } from '../../modal/modal.component';
import { BaseMenuComponent } from '../base.menu';
import { PeopleService } from '../../shared/services';
import { InspectionPlugin } from '../../shared/models';

@Component({
    templateUrl: './base.menu.html',
    standalone: false
})
export class BasePluginMenuComponent extends BaseMenuComponent {
  public currentPerson: any;
  private plugin: InspectionPlugin;

  constructor(public modal: ModalComponent, private peopleService: PeopleService) {
    super(modal);
    this.modal.hasClassModal = true;
    this.peopleService.getCurrent().subscribe((res) => (this.currentPerson = res));
  }

  init(data: any) {
    this.plugin = data?.plugin;
  }

  public get isInOffline() {
    return !!this.plugin?.inspection?.isOffline;
  }
}
